import { formatFileSize } from '@fabric-app/utils/number';

const getToastMessageCapHit = (currentPlan, entitlement) => {
  switch (entitlement) {
    case "maxFileSizeMB":
      return `${formatFileSize(currentPlan.entitlements.maxFileSizeMB * 1e3 * 1e3)} upload limit`;
    case "maxTotalStorageSizeMB":
      return `Out of storage space!`;
    case "creditCentsMonthly":
      return `Out of thinking credits!`;
    default:
      return null;
  }
};

export { getToastMessageCapHit };
//# sourceMappingURL=getToastMessageCapHit.js.map
